class WishlistStore {
  static KEY = 'horizon_wishlist';

  static getAll() {
    try {
      const raw = localStorage.getItem(this.KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  static save(list) {
    localStorage.setItem(this.KEY, JSON.stringify(list));
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { count: list.length, items: list } })
    );
  }

  static has(handle) {
    return this.getAll().includes(handle);
  }

  static toggle(handle) {
    const list = this.getAll();
    const idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    this.save(list);
    return list.includes(handle);
  }

  static remove(handle) {
    const list = this.getAll().filter((h) => h !== handle);
    this.save(list);
  }

  static count() {
    return this.getAll().length;
  }
}

window.WishlistStore = WishlistStore;

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.productHandle;
    this.button = this.querySelector('button');
    this.updateState();
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const active = WishlistStore.toggle(this.handle);
      this.updateState(active);
    });
    document.addEventListener('wishlist:updated', () => this.updateState());
  }

  updateState(activeOverride) {
    const active = typeof activeOverride === 'boolean' ? activeOverride : WishlistStore.has(this.handle);
    this.button.classList.toggle('is-active', active);
    this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }
}

customElements.define('wishlist-button', WishlistButton);

class WishlistCount extends HTMLElement {
  connectedCallback() {
    this.updateCount();
    document.addEventListener('wishlist:updated', (e) => this.updateCount(e.detail.count));
  }

  updateCount(count) {
    const n = typeof count === 'number' ? count : WishlistStore.count();
    this.textContent = n;
    this.hidden = n === 0;
  }
}

customElements.define('wishlist-count', WishlistCount);